<template>
  <PageTemplate>
    <h1>{{ getTitleText() }}</h1>
    <div class="row">
      <div class="col-lg-9">
        <v-card :title="getTitleText()">
          <v-fieldset
            id="title"
            v-model="discussionTitle"
            text="Discussion Title"
            is-required
            :maxlength="100"
          />
          <v-fieldset
            v-if="categories.length > 0"
            id="category"
            v-model="category"
            :value="category"
            text="Category"
            placeholder="Select"
            :select-options="categories"
            is-required
          />
          <fieldset class="fieldset">
            <v-label text="Description" />
            <v-wysiwyg
              v-if="loaded"
              v-model="postContent"
              class="wysiwyg"
              placeholder="Enter content"
              @trix-file-accept="fileAccept"
              @trix-attachment-add="attachmentAdd"
              @trix-attachment-remove="attachmentRemove"
            />
          </fieldset>
          <fieldset
            v-if="files.length !== 0"
            class="fieldset"
          >
            <v-label text="Attachments" />
            <v-file-upload
              v-for="(file, index) in files"
              :key="index"
              :file-name="file.name"
              is-small
              @clear="attachmentRemove(file)"
            />
          </fieldset>
        </v-card>
        <v-button-group>
          <v-button
            size="lg"
            has-min-width
            :is-disabled="disablePost"
            @click="post"
          >
            Post
          </v-button>

          <v-button
            size="lg"
            color="secondary"
            has-min-width
            @click="performCancel"
          >
            Cancel
          </v-button>
        </v-button-group>
      </div>
    </div>
  </PageTemplate>
</template>
<script>
import PageTemplate from "@/templates/Page/index.vue";
import Card from "@/molecules/Card";
import Fieldset from "@/molecules/Fieldset";
import FileUpload from "@/molecules/FileUpload";
import ButtonGroup from "@/molecules/ButtonGroup";
import Label from "@/atoms/Label";
import Button from "@/atoms/Button";
import VueTrix from "vue-trix";
import { buildBreadCrumb } from "@/common/tableFunctions";
import { addBlankTargets } from "@/common/formatting";
import routes from "@/common/routes";
import {
  GET_FORUM_CATEGORIES,
  CREATE_FORUM_THREAD,
  EDIT_FORUM_THREAD,
  DELETE_FORUM_THREAD
} from "@/store/actions.type";

export default {
  name: "NewDiscussion",
  components: {
    "v-card": Card,
    "v-fieldset": Fieldset,
    "v-label": Label,
    "v-wysiwyg": VueTrix,
    "v-button": Button,
    "v-button-group": ButtonGroup,
    "v-file-upload": FileUpload,
    PageTemplate
  },
  data() {
    return {
      isEditMode: false,
      postContent: "",
      files: [],
      discussionTitle: "",
      category: 1,
      categories: [],
      disablePost: true,
      selectedThread: {},
      loaded: false
    };
  },
  watch: {
    discussionTitle: {
      handler: "enableDisablePostBtn"
    },
    postContent: {
      handler: "enableDisablePostBtn"
    }
  },
  mounted() {
    //This call Is removed to Hide Category Association with New/Edit Discussion - NATA-1090
    // this.getCategories();
    this.isEditMode =
      "edit-discussion" === this.$route.name && this.$route.params.id;
    if (this.isEditMode) {
      this.setSelectedThread();
    }else {
      this.loaded = true;
    }
    this.updateBreadCrumb();
  },
  methods: {
    updateBreadCrumb: function() {
      let breadcrumbs = [];
      breadcrumbs["Dashboard"] = routes.DASHBOARD;
      breadcrumbs["Forum"] = routes.FORUM;
      breadcrumbs[this.getTitleText()] = "";
      this.$store.dispatch(
        "updateBreadCrumbAction",
        buildBreadCrumb(breadcrumbs)
      );
    },
    setSelectedThread() {
      if (!this.isEditMode) {
        this.loaded = true;
        return {};
      }
      let id = this.$route.params.id;
      // read selected thread from store and verify id.
      // If id mismatch then there is some Issue - may be user hit this url directly.
      if (id !== "" + this.$store.state.forums.selectedThread.id) {
        this.$router.push({ name: "forum" });
        return {};
      }
      this.selectedThread = this.$store.state.forums.selectedThread;
      // update title
      this.discussionTitle = this.selectedThread.title;
      // update thread category
      if (
        this.selectedThread.categories &&
        this.selectedThread.categories.length > 0
      ) {
        this.category = this.selectedThread.categories[0].id;
      }
      this.postContent = this.selectedThread.post;
      // updating attached documents
      this.files = this.selectedThread.documents;
      this.loaded = true;
    },
    getTitleText() {
      return this.isEditMode ? "Edit Discussion" : "Add New Discussion";
    },
    getCategories() {
      return this.$store
        .dispatch(GET_FORUM_CATEGORIES, {})
        .then(response => {
          this.categories = response;
          this.categories.map(ele => {
            ele.label = ele.name;
            ele.value = ele.id;
          });
        })
        .catch(err => {
          console.error("Error: While loading categories. " + err);
        });
    },
    fileAccept(e) {
      // check if this file is already attached.
      if (this.files.filter(ele => ele.name === e.file.name).length > 0) {
        alert("Error: This file is already attached. Please remove duplicate.");
        e.preventDefault();
        return false;
      }
    },
    attachmentAdd(evt) {
      console.log("Attached:");
      console.log(evt);

      // 1. get file object
      let file = evt.attachment.file;
      this.files.push(file);
    },
    attachmentRemove(evt) {
      let fileName = evt.attachment ? evt.attachment.file.name : evt.name;
      this.files = this.files.filter(ele => ele.name !== fileName);
    },
    post() {
      this.disablePost = true;
      var formData = new FormData();
      // adding attachement files
      if (this.files) {
        this.files.forEach((file, index) => {
          if (file.uploadable_id) {
            formData.append("existingFiles[]", file.name);
          } else formData.append("files[]", file);
        });
      }
      formData.append("committeId", this.$store.getters.getSelectedCommittee);
      formData.append("filesCount", this.files.length);
      formData.append("postContent", addBlankTargets(this.postContent));
      formData.append("discussionTitle", this.discussionTitle);
      formData.append("categories", this.category);
      if (this.isEditMode) {
        formData.append("threadId", this.selectedThread.id);
        formData.append("_method", "put");
        this.performEditThreadAction({
          formData: formData,
          id: this.selectedThread.id
        });
      } else {
        this.performCreateNewThreadAction(formData);
      }
    },
    performEditThreadAction(formData) {
      let res = this.$store
        .dispatch(EDIT_FORUM_THREAD, formData)
        .then(response => {
          this.$store.state.forums.forums = [];
          // Navigate to Forum thread details page.
          this.performCancel();
          this.disablePost = false;
          this.$notify({
            title: "Discussion Thread Edited",
            text: "Discussion Thread created updated.",
            type: "success"
          });
        })
        .catch(err => {
          this.disablePost = false;
          this.$notify({
            title: "Error:",
            text: err,
            type: "error"
          });
        });
    },
    performCreateNewThreadAction(formData) {
      let res = this.$store
        .dispatch(CREATE_FORUM_THREAD, formData)
        .then(response => {
          this.$store.state.forums.forums = [];
          // Navigate to Forum thread listing page.
          this.performCancel();
          this.disablePost = false;
          this.$notify({
            title: "New Discussion Thread Added",
            text: "Discussion Thread created Successfully.",
            type: "success"
          });
        })
        .catch(err => {
          this.disablePost = false;
          this.$notify({
            title: "Error:",
            text: err,
            type: "error"
          });
        });
    },
    performCancel(evt) {
      if (this.isEditMode) {
        this.$router.push({
          name: "discussion",
          params: { id: this.$route.params.id }
        });
      } else {
        this.$router.push({ name: "forum" });
      }
    },
    enableDisablePostBtn() {
      this.disablePost = this.discussionTitle === "";
      if(!this.disablePost) {
        this.disablePost = this.postContent === "";
      }
    }
  }
};
</script>
